
import Statistics from '../../Components/HomePage/statistics';
import StackedAreaChart from '../../Components/HomePage/lineChart';

export default function HomePage () {
    return(
        <>
        <Statistics/>
        <StackedAreaChart/>
        </>
    )
}